/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/*
 * op payment api
 */

var ajaxAdapter = require('./util/ajax-adapter');
var browserData = require('./browser-data.service');

/**
 * Performs a LIST request and call the callback provided
 *
 * @param listUrl The URL for the list request
 * @param callback function to be called after response arrived
 * @param bindingData data transferred to callback
 */
function listRequest(listUrl, callback, bindingData, visualErrorCallback) {
    var system = {
        type: 'GET',
        dataType: 'json',
        contentType: 'application/vnd.optile.payment.simple-v1+json',
        url: listUrl,
    };
    ajaxAdapter(system)
        .fail(function (err) {
            err.request = system;
            callback(err, null, bindingData, visualErrorCallback);
        })
        .done(function (data) {
            callback(null, data, bindingData, visualErrorCallback);
        });
}

/**
 * Delete an account.
 *
 * @param url The URL to be used for the delete request
 * @param callback function to be called after response arrived
 * @param bindingData data transferred to callback
 */

function deleteAccount(url, callback, bindingData) {
    var system = {
        type: 'DELETE',
        url: url,
    };
    ajaxAdapter(system)
        .fail(function (err) {
            err.request = system;
            callback(err, null, bindingData);
        })
        .done(function (data) {
            callback(null, data);
        });
}

/**
 * Validates an account.
 *
 * @param validationUrl The URL to be used for the validation
 * @param requestData The data sent to the validation service
 * @param callback function to be called after response arrived
 * @param bindingData data transferred to callback
 */
function validateAccount(validationUrl, requestData, callback, bindingData) {
    var system = {
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(requestData),
        contentType: 'application/json',
        url: validationUrl,
    };
    ajaxAdapter(system)
        .fail(function (err) {
            err.request = system;
            callback(err, null, bindingData);
        })
        .done(function (data) {
            callback(null, data, bindingData);
        });
}
/**
 * Validates an account by checking the order of response to ignore out of order responses
 *
 * @param validationUrl The URL to be used for the validation
 * @param requestData The data sent to the validation service
 * @param callback function to be called after response arrived
 * @param bindingData data transferred to callback
 */
function validateAccountByOrder(validationUrl, requestData, callback, bindingData) {
    var callId = bindingData.rootScope.incrementAndGetLastValidationResponseId();
    var system = {
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(requestData),
        contentType: 'application/json',
        url: validationUrl,
    };
    ajaxAdapter(system)
        .fail(function (err) {
            err.request = system;
            callback(err, null, bindingData);
        })
        .done(function (data) {
            var responseId = bindingData.rootScope.getLastValidationResponseId();
            if (callId >= responseId) {
                bindingData.rootScope.setLastValidationResponseId(callId);
                callback(null, data, bindingData);
            }
        });
}

/**
 * Retrieves the HTML code for a form.
 *
 * @param url
 * @param callback function to be called after response arrived
 * @param bindingData data transferred to callback
 */
function getLocalizedForm(url, callback, bindingData) {
    var system = {
        url: url,
    };
    ajaxAdapter(system)
        .fail(function (err) {
            err.request = system;
            callback(err, null, bindingData);
        })
        .done(function (data) {
            callback(null, data, bindingData);
        });
}

/**
 * Performs a CHARGE/UPDATE request.
 *
 * @param operationUrl The form URL
 * @param requestData The request data to be sent
 * @param callback function to be called after response arrived
 * @param bindingData data transferred to callback
 */
function operationRequest(operationUrl, requestData, callback, bindingData) {
    requestData.browserData = browserData;
    var system = {
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(requestData),
        contentType: 'application/json',
        url: operationUrl,
    };
    ajaxAdapter(system)
        .fail(function (err) {
            err.request = system;
            callback(err, null, bindingData);
        })
        .done(function (data) {
            if (requestData.account) {
                data.requestAccount = requestData.account;
            }
            callback(null, data, bindingData);
        });
}

module.exports = {
    listRequest: listRequest,
    deleteAccount: deleteAccount,
    validateAccount: validateAccount,
    getLocalizedForm: getLocalizedForm,
    operationRequest: operationRequest,
    validateAccountByOrder: validateAccountByOrder,
};
